import styled from 'styled-components';
import { styled as muiStyle, CSSObject } from '@mui/material/styles';
import { StyledIconButtonProps } from '../';
import { IconButton as MuiIconButton, IconButtonProps as MuiIconButtonProps } from '@mui/material';

export type ExtendedButtonProps = MuiIconButtonProps & StyledIconButtonProps;

export const Text = styled.div`
  width: 100%;
  height: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const sizeMixin = (size: string): CSSObject => ({
  ...(size === `small` && {
    width: `18px`,
    height: `18px`
  }),
  ...(size === `medium` && {
    width: `24px`,
    height: `24px`
  }),
  ...(size === `large` && {
    width: `30px`,
    height: `30px`
  })
});

export const StyledEditButton = muiStyle(MuiIconButton, {
  shouldForwardProp: (prop) => !['circled', 'hover', 'loading', 'active'].includes(String(prop)) //(prop) => prop !== 'circled' && prop !== 'loading',
})<ExtendedButtonProps>(({ theme, variant, color, circled, size, active, loading, disabled }) => ({
  border: `1px dashed ${theme.palette.secondary[600]}`,
  backgroundColor: theme.palette.grayscaleSecondary[50],
  padding: `0px`,
  borderRadius: `50%`,
  boxSizing: `border-box`,
  transition: `all linear 0.2s`,
  '.MuiSvgIcon-root': {
    color: theme.palette.secondary.main,
    transition: `all linear 0.2s`
  },
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
    borderColor: theme.palette.secondary.main,
    '.MuiSvgIcon-root': {
      color: theme.palette.secondary.contrastText
    }
  },
  '&.Mui-disabled': {
    opacity: `.5`
  },
  ...(size !== undefined && sizeMixin(size))
}));
